"use client";

import React, { useEffect, useState, useCallback, useRef } from "react";
import Link from "next/link";
import { HiArrowRight } from "react-icons/hi";

const SCROLL_THRESHOLD = 80;

const MobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const lastScrollYRef = useRef(0);
  const [isMobile, setIsMobile] = useState(false);

  const checkMobile = useCallback(() => {
    setIsMobile(typeof window !== "undefined" && window.innerWidth < 768);
  }, []);

  useEffect(() => {
    checkMobile();
    const handleResize = () => checkMobile();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [checkMobile]);

  useEffect(() => {
    if (!isMobile) return;

    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        const currentScrollY =
          window.scrollY || document.documentElement.scrollTop;
        const lastScrollY = lastScrollYRef.current;

        // Show when scrolling DOWN
        if (currentScrollY > SCROLL_THRESHOLD && currentScrollY > lastScrollY) {
          setIsVisible(true);
        }

        // Hide when scrolling UP
        if (currentScrollY < lastScrollY) {
          setIsVisible(false);
        }

        lastScrollYRef.current = currentScrollY;
        ticking = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobile]);

  if (!isMobile) return null;

  return (
    <div
      className={`fixed bottom-5 left-1/2 -translate-x-1/2 z-[9980] md:hidden transition-all duration-300 ease-out ${
        isVisible ? "translate-y-0 opacity-100" : "translate-y-20 opacity-0"
      }`}
    >
      <Link
        href="/contact-us"
        className="flex items-center gap-2 px-12 w-full py-3 rounded-full bg-primary hover:bg-primary/90 text-white font-medium text-sm shadow-lg transition-all"
      >
        <span>Contact Us</span>
        <HiArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};

export default React.memo(MobileCTA);